import React from "react";
import styled from "styled-components";
import Header from "./Header.jsx";
import Footer from "./TechSiteFooter.jsx";
import LanguageSync from "../language/LanguageSync.jsx";
import { Outlet, useLocation } from "react-router-dom";

const Main = styled.main`
 -- min-height: calc(100vh -160px);
--  padding-bottom: 3rem; 
`;

const Layout = () => {
  const location = useLocation();

  const hideHeaderPaths = [""];

  const shouldHideHeader = hideHeaderPaths.includes(location.pathname);

  return (
    <>
      <LanguageSync>
        {!shouldHideHeader && <Header />}
        <Main>
          <Outlet />
        </Main>
        <Footer />
      </LanguageSync>
    </>
  );
};

export default Layout;
